const overspeedAlarm = {
  licensePlate: "车牌号码",
  AlarmInfo: "报警信息",
  Type: "报警类型",
  faultTime: "报警时间",
  startTime: "报警开始时间",
  alarmStartSpeed: "报警开始车速(km/h)",
  alarmEndSpeed: "报警结束车速(km/h)",
  startLocation: "报警开始地点",
  endLocation: "报警结束地点",
  endTime: "报警结束时间"
} 
export default overspeedAlarm